/**
 * Document method patches to add support for shadow DOM traversal when querySelecting.
 * Using Proxy to override the default because it's more compatible
 * with Cypress' query selection(Jquery->Sizzle.js). There were conflicts when
 * using query-selector-ponyfill or other manual patches.
 */
document.querySelector = new Proxy(document.querySelector, {
  apply(target, context, [selectors]) {
    const elem = target.apply(context, [selectors]);
    if (!elem) {
      return (
        target
          .apply(context, ['classic-content-wrapper'])
          ?.shadowRoot?.querySelector(selectors) || null
      );
    }
    return elem;
  },
});

document.querySelectorAll = new Proxy(document.querySelectorAll, {
  apply(target, context, [selectors]) {
    const elem = target.apply(context, [selectors]);
    if (!elem) {
      return (
        target
          .apply(context, ['classic-content-wrapper'])[0]
          ?.shadowRoot?.querySelectorAll(selectors) || []
      );
    }
    return elem;
  },
});

document.getElementById = new Proxy(document.getElementById, {
  apply(target, context, [selectors]) {
    const elem = target.apply(context, [selectors]);
    if (!elem) {
      return (
        document
          .querySelector('classic-content-wrapper')
          ?.shadowRoot?.getElementById(selectors) || null
      );
    }
    return elem;
  },
});
